import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth, DoctorContextProvider } from "@contexts";
import { getStoredTokens, isTokenExpired } from "@utils";
import { FullScreenLoader } from "@components";

export function PrivateRoute() {
  const navigate = useNavigate();
  const { setIsUserAuthed, isRestoringSession } = useAuth();

  useEffect(() => {
    if (isRestoringSession) return;
    const tokens = getStoredTokens();

    console.log("tokens", tokens);
    if (tokens && !isTokenExpired(tokens.idToken)) {
      setIsUserAuthed(true);
    } else {
      navigate("/");
    }
    // dont put navigate on the dependencies array, we want this only to happen once restoration is done
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRestoringSession]);

  if (isRestoringSession) return <FullScreenLoader />;

  return (
    <DoctorContextProvider>
      <Outlet />
    </DoctorContextProvider>
  );
}
